import '@fontsource/roboto'
import { createTheme, ThemeProvider } from '@material-ui/core'
import './App.css'
import { Home } from './pages/home'
import { ContextProvider } from './state'
import { MetaMaskProvider } from './utils/metamask'

const theme = createTheme({
  typography: {
    fontFamily: 'Roboto Condensed, sans-serif',
  },
})

const App = () => (
  <div className="App">
    <ThemeProvider theme={theme}>
      <MetaMaskProvider>
        <ContextProvider>
          <Home />
        </ContextProvider>
      </MetaMaskProvider>
    </ThemeProvider>
  </div>
)

export default App
